import React from 'react';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/nl';
import 'moment/locale/it';
import 'moment/locale/pt';
import 'moment/locale/de';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { ThroughProvider } from 'react-through';
import { ThemeProvider } from 'styled-components';
import { ConnectedRouter } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import { PersistGate } from 'redux-persist/lib/integration/react';

import { env } from './env';
import { configureStore } from './store';
import { theme } from './style/constants';
import { DEFAULT_LOCALE } from './constants/locale';
import { APPLICATION_ID, NO_FRONT_APPS } from './constants';

import { getLocaleFromLocation } from './services/i18n/utils';

import App from './components/App';
import TrackingProvider from './tracking/provider';

//TODO Replace scss util classes by styled-components
import './scss/index.scss';
import GlobalStyles from './style/GlobalStyles';

const history = createHistory();

const { store, persistor } = configureStore(history);

// set Momentjs locale
const locale = getLocaleFromLocation(DEFAULT_LOCALE);
moment.locale(locale);

// set Favicon in relation to applications specifics
window.onload = () => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = `${env.PUBLIC_URL}/favicons/${APPLICATION_ID}/favicon.ico`;
};

// When embedded in a parent iframe (e.g. leboncoin), report content size so
// the parent can resize the iframe and avoid a non-functional inner scroll.
if (window.parent !== window) {
    const reportWindowSize = () => {
        window.parent.postMessage(
            {
                width: document.body.scrollWidth,
                height: document.body.scrollHeight,
                scrollToTop: true
            },
            '*'
        );
    };
    if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(reportWindowSize).observe(document.body);
    } else {
        window.addEventListener('load', reportWindowSize);
        window.addEventListener('resize', reportWindowSize);
    }
}

if (!NO_FRONT_APPS) {
    render(
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <PersistGate loading={null} persistor={persistor}>
                    <ConnectedRouter history={history}>
                        <CookiesProvider>
                            <ThroughProvider>
                                <TrackingProvider>
                                    <GlobalStyles />
                                    <App />
                                </TrackingProvider>
                            </ThroughProvider>
                        </CookiesProvider>
                    </ConnectedRouter>
                </PersistGate>
            </ThemeProvider>
        </Provider>,
        document.getElementById('root')
    );
}



// WEBPACK FOOTER //
// ./src/index.js